import React, { useContext } from "react";
import { Button, Card, CardContent } from "@material-ui/core";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import HistoryOutlinedIcon from "@mui/icons-material/HistoryOutlined";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import styles from "../users.module.scss";
import AuthContext from "../../../hooks/authContext";
import { packageAccess } from "../../../services/helpers";

const CancelStep1 = (props) => {
  const { setDisplayStep, data, prices } = props;
  const auth = useContext(AuthContext);
  const userPackageId = auth?.userProfile?.prdId;
  const allowedPermissions = packageAccess(userPackageId);

  const formatStorage = (bytes) => {
    if (bytes >= 1 * 1024 * 1024 * 1024 * 1024) {
      return `${Math.floor(bytes / (1024 ** 4))} TB`;
    }
    if (bytes >= 1024 * 1024 * 1024) {
      return `${Math.floor(bytes / (1024 ** 3))} GB`;
    }
    if (bytes >= 1024 * 1024) {
      return `${Math.floor(bytes / (1024 ** 2))} MB`;
    }
    return `${Math.floor(bytes / 1024)} KB`;
  };

  const cmsFeatures = [
    "Full CMS / Webportal Access",
    "Custom Integration",
    "Full Mobile app for Field Teams",
    "Alerts and seamless notifications",
    "Real-time chat with unlimited messaging",
    "Supplies Management",
    "Issues Management",
    "Comprehensive Reporting for your team and your clients",
    `It includes a maximum limit of ${allowedPermissions?.userLimit} users`,
    `It includes a maximum storage limit of ${formatStorage(allowedPermissions?.storageLimits)}`
  ];

  return (
    <div style={{ maxWidth: "800px", margin: "0px auto" }}>
      <div>
        <div className="mb-15">
          <Button onClick={() => setDisplayStep(0)} className="pl-0">
            <span className="d-flex flex-center dark:text-white text-[#6B7280]">
              {" "}
              <KeyboardBackspaceIcon className="mr-8" fontSize="small" />
              Back to Billing
            </span>
          </Button>
        </div>

        <div>
          <h3 className="dark:text-white text-[#020817]" style={{ fontSize: "24px", fontWeight: "700" }}>
            Cancel Subscription
          </h3>
          <p
            className="mb-0 mt-10 dark:text-white text-[#020817]" style={{ fontSize: "14px", lineHeight: "20px" }}
          >
            {" "}
            Please review your subscription details before cancelling.{" "}
          </p>
        </div>
      </div>

     <Card
      className="mt-30 bg-[#ffffff] dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] border border-[hsl(214.3,31.8%,91.4%)] dark:border-transparent rounded-[6px]"
      >
        <div className="p-24">
          <h3 className="dark:text-white text-[#020817]" style={{ fontSize: "24px", fontWeight: "600" }}>
            {" "}
            Current Plan Details{" "}
          </h3>
        </div>
        <CardContent style={{ padding: "0px 24px 24px 24px" }}>
          <Card
            className="mb-24 bg-[#ffffff] dark:bg-[#2c3440] dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] border border-[hsl(214.3,31.8%,91.4%)] dark:border-transparent rounded-[8px]"
          >
            <CardContent className="p-24">
              <div className={styles.infoContainer}>
                <div className={styles.infoItem}>
                  <HistoryOutlinedIcon className={styles.infoIconBlue} />
                  <div>
                    <h3 className={`${styles.infoTitle} dark:text-white`}>
                      Cancellation Information
                    </h3>
                    <p className={`${styles.infoText} dark:text-gray-400`}>
                      Your subscription will remain active until the end of your
                      current billing period. You will not be charged again
                      after this period.
                    </p>
                  </div>
                </div>

                <div className={styles.infoItem}>
                  <ErrorOutlineOutlinedIcon className={styles.infoIconYellow} />
                  <div>
                    <h3 className={`${styles.infoTitle} dark:text-white`}>Refund Policy</h3>
                    <p className={`${styles.infoText} dark:text-gray-400`}>
                      No refunds are issued for partial months. Your access
                      continues until the end of the current billing period.
                    </p>
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>

          <div className={styles.featuresContainer}>
            <h4 className={`${styles.featuresTitle} dark:text-green-600 text-[#020817]`}>
              Features you'll lose access to:
            </h4>
            <ul className={styles.featureList}>
              {cmsFeatures?.map(
                (feature, index) => (
                  <li key={index} className={`${styles.featureItem} dark:text-white text-[#4b5563]`}>
                    <span className={styles.bullet}></span>
                    {feature}
                  </li>
                )
              )}
            </ul>
          </div>
        </CardContent>
      </Card>

      <div className="d-flex flex-center flex-justify-end mt-20">
        <Button
          style={{ backgroundColor: "#ffffff", color: "black" }}
          variant="outlined"
          onClick={() => setDisplayStep(0)}
        >
          Keep Subscription
        </Button>
        <Button
          className="ml-10"
          style={{ backgroundColor: "green", color: "white" }}
          variant="contained"
          onClick={() => setDisplayStep(2)}
        >
          Continue to Cancel
        </Button>
      </div>
    </div>
  );
};

export default CancelStep1;
